import React from 'react';
import {PieChart, Pie, Sector, Cell} from 'recharts';
import {CardBlock, EmptyCircle, MiniCardBlock} from './Evaluation.styled'

// chart func from library to calculate angled line to criterion Value
const renderActiveShape = (items) => {
  const RADIAN = Math.PI / 180;
  const {cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, value} = items;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 10) * cos;
  const my = cy + (outerRadius + 10) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 10;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none"/>
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none"/>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{value}</text>
    </g>
  );
};

export default class TotalEvaluationChart extends React.Component<any, any> {

  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
  }

  onPieEnter = (_, index) => {
    this.setState({
      activeIndex: index,
    });
  };

  colorPicker(type: string): string {
    let criteriaColors = {
      env: "#667B3B",
      soc: "#36537B",
      eco: "#B57031",
      loc: "#555555"
    }
    switch (type) {
      case "E": {
        return criteriaColors.env
      }
      case "S": {
        return criteriaColors.soc
      }
      case "C": {
        return criteriaColors.eco
      }
      case "L": {
        return criteriaColors.loc
      }
      default:
        break;
    }
  }

   generateData(criteria) {
    let data = []
    criteria.forEach(criterion=> {
      const value =  criterion.totalScore ? criterion.totalScore : 0
      data.push({name: criterion.criterionCode, value: Number(value.toFixed(1))})
    })
    return data
  }

  render() {
    let {criteria, withCharts, total} = this.props
    const totalResult = total > 0 ? total.toFixed(1) : '0.0'

    return (
      <div>
        {withCharts ?
          <CardBlock>
            <span className="score">{totalResult}</span>
            {total && total > 0 ? <PieChart width={160} height={120}>
                <Pie
                  activeIndex={this.state.activeIndex}
                  activeShape={renderActiveShape}
                  data={this.generateData(criteria)}
                  cx="50%"
                  cy="50%"
                  innerRadius={15}
                  outerRadius={30}
                  fill="#018A00"
                  dataKey="value"
                  onMouseEnter={this.onPieEnter}
                  minAngle={5}
                >
                  {criteria.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={this.colorPicker(entry.type)}/>))}
                </Pie>
              </PieChart>
              :
              <EmptyCircle
                color={`linear-gradient(90deg, rgba(102,123,59,1) 0%, rgba(54,83,123,1) 35%, rgba(181,112,49,1) 69%, rgba(85,85,85,1) 100%)`}/>
            }
          </CardBlock>
          :
          <MiniCardBlock>
            <span className="score">{totalResult}</span>
          </MiniCardBlock>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/sbtool/component/ProjectVersionParamsForm/EvaluationGrid/TotalEvaluationChart.tsx